import React from 'react'
import { useMutation } from '@apollo/client'
import { toast } from 'react-toastify'
import { GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID } from '../../../../graphql/query'
import { DELETE_FORM_BUILDER_BY_FORM_ID } from '../../../../graphql/mutation'

interface Props {
  formInfo: any
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  closeDeleteModal: () => void
}

const DeleteFormModal: React.FC<Props> = ({ formInfo, setIsLoading, closeDeleteModal }) => {
  const [DeleteForm] = useMutation(DELETE_FORM_BUILDER_BY_FORM_ID, {
    refetchQueries: [
      {
        query: GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID,
        variables: {
          input: {
            formUuid: null
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Form-Builder'
          }
        }
      }
    ],

    context: {
      headers: {
        'access-control-allow-methods': 'Form-Builder'
      }
    }
  })
  console.log(formInfo)
  const deleteThisForm = (formUuids: any) => {
    setIsLoading(true)

    DeleteForm({
      variables: {
        input: {
          formUuid: formUuids
        }
      }
    })
      .then((res: any) => {
        setIsLoading(false)
        closeDeleteModal()
        if (res) {
          toast.success(res.data.deleteFormBuilderByFormId.message)
        } else {
          toast.error('Unable to delete Form')
        }
      })
      .catch((err) => {
        setIsLoading(false)
        toast.error('Sorry! Unexpected Error.')
        console.log(err)
      })
  }

  return (
    <div className='card-body'>
      <p className='fs-5 fw-bold'>Are you sure you want to delete the following Form ?</p>
      <div className='card-text'>
        Form Name: <strong> {formInfo.name.replace(/[_\-]/g, ' ').replace(/[^\w\s]/gi, '')}</strong>
      </div>
      <div className='card-text'>
        Form Description: <strong>{formInfo.name}</strong>
      </div>

      <div className='d-flex justify-content-end mt-10'>
        <button
          type='reset'
          className='btn btn-sm btn-white btn-active-light-primary me-2'
          onClick={closeDeleteModal}
        >
          Cancel
        </button>

        <button
          type='submit'
          className='btn btn-sm btn-danger'
          onClick={() => {
            deleteThisForm(formInfo.formUuid)
          }}
        >
          <span className='indicator-label'>Delete</span>
        </button>
      </div>
    </div>
  )
}

export default DeleteFormModal
